export const patterns = {
  zipRegexp: /\b\d{5}\b/
};

export const UNIREG_PHONE_NUMBER_PATTERN =
  /^[1-9][0-9]{2}-?[0-9]{3}-?[0-9]{4}$/;

export const PHONE_NUMBER_PATTERN = /^\([1-9][0-9]{2}\)\s[0-9]{3}-[0-9]{4}$/;
export const BLOOD_SUGAR_PATTERN = /^\d+$/g;
